/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InfusionAdministrationByScheduleAliases {
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INFUSION_ADMIN_BY_SCHEDULE_ACCORDION = 'infusion-admin-by-schedule-accordion',
  INFUSION_ADMIN_BY_SCHEDULE_ACCORDION_PANEL = 'infusion-admin-by-schedule-accordion-panel',
  INFUSION_ADMIN_BY_SCHEDULE_ACCORDION_PLUS_TITLE_PANEL = 'infusion-admin-by-schedule-accordion-plus-title-panel',
  INFUSION_ADMIN_BY_SCHEDULE_ACCORDION_PLUS_TITLE_TEXT = 'infusion-admin-by-schedule-accordion-plus-title-text',
  INFUSION_ADMIN_BY_SCHEDULE_ACCORDION_TITLE_PANEL = 'infusion-admin-by-schedule-accordion-title-panel',
  INFUSION_ADMIN_BY_SCHEDULE_ACCORDION_TITLE_TEXT = 'infusion-admin-by-schedule-accordion-title-text',
  INFUSION_ADMIN_BY_SCHEDULE_ADMIN_ROUTE_AUTOCOMPLETE = 'infusion-admin-by-schedule-admin-route-autocomplete',
  INFUSION_ADMIN_BY_SCHEDULE_ADMIN_ROUTE_FETCH = 'infusion-admin-by-schedule-admin-route-fetch',
  INFUSION_ADMIN_BY_SCHEDULE_ADMIN_ROUTE_FIELD = 'infusion-admin-by-schedule-admin-route-field',
  INFUSION_ADMIN_BY_SCHEDULE_ADMIN_ROUTE_MAPPER = 'infusion-admin-by-schedule-admin-route-mapper',
  INFUSION_ADMIN_BY_SCHEDULE_ADMIN_ROUTE_TEXT = 'infusion-admin-by-schedule-admin-route-text',
  INFUSION_ADMIN_BY_SCHEDULE_BARCODE = 'infusion-admin-by-schedule-barcode',
  INFUSION_ADMIN_BY_SCHEDULE_BARCODE_PANEL = 'infusion-admin-by-schedule-barcode-panel',
  INFUSION_ADMIN_BY_SCHEDULE_BUTTON = 'infusion-admin-by-schedule-button',
  INFUSION_ADMIN_BY_SCHEDULE_BUTTON_PANEL_PADDING = 'infusion-admin-by-schedule-button-panel-padding',
  INFUSION_ADMIN_BY_SCHEDULE_CARD = 'infusion-admin-by-schedule-card',
  INFUSION_ADMIN_BY_SCHEDULE_CARD_DECK = 'infusion-admin-by-schedule-card-deck',
  INFUSION_ADMIN_BY_SCHEDULE_CARD_PANEL = 'infusion-admin-by-schedule-card-panel',
  INFUSION_ADMIN_BY_SCHEDULE_CARDS_ACCORDION = 'infusion-admin-by-schedule-cards-accordion',
  INFUSION_ADMIN_BY_SCHEDULE_CARDS_ACCORDION_PANEL = 'infusion-admin-by-schedule-cards-accordion-panel',
  INFUSION_ADMIN_BY_SCHEDULE_CONTENT_PANEL = 'infusion-admin-by-schedule-content-panel',
  INFUSION_ADMIN_BY_SCHEDULE_DATE_TIME_FIELD = 'infusion-admin-by-schedule-date-time-field',
  INFUSION_ADMIN_BY_SCHEDULE_DATE_TIME_TEXT = 'infusion-admin-by-schedule-date-time-text',
  INFUSION_ADMIN_BY_SCHEDULE_DEVICE_AUTOCOMPLETE = 'infusion-admin-by-schedule-device-autocomplete',
  INFUSION_ADMIN_BY_SCHEDULE_DEVICE_FETCH = 'infusion-admin-by-schedule-device-fetch',
  INFUSION_ADMIN_BY_SCHEDULE_DEVICE_FIELD = 'infusion-admin-by-schedule-device-field',
  INFUSION_ADMIN_BY_SCHEDULE_DEVICE_MAPPER = 'infusion-admin-by-schedule-device-mapper',
  INFUSION_ADMIN_BY_SCHEDULE_DEVICE_TEXT = 'infusion-admin-by-schedule-device-text',
  INFUSION_ADMIN_BY_SCHEDULE_DILUTION_FIELD = 'infusion-admin-by-schedule-dilution-field',
  INFUSION_ADMIN_BY_SCHEDULE_DILUTION_TEXT = 'infusion-admin-by-schedule-dilution-text',
  INFUSION_ADMIN_BY_SCHEDULE_FORM = 'infusion-admin-by-schedule-form',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_FORM_AUTOCOMPLETE = 'infusion-admin-by-schedule-infusion-form-autocomplete',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_FORM_FETCH = 'infusion-admin-by-schedule-infusion-form-fetch',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_FORM_FIELD = 'infusion-admin-by-schedule-infusion-form-field',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_FORM_MAPPER = 'infusion-admin-by-schedule-infusion-form-mapper',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_FORM_TEXT = 'infusion-admin-by-schedule-infusion-form-text',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_SPEED_FIELD = 'infusion-admin-by-schedule-infusion-speed-field',
  INFUSION_ADMIN_BY_SCHEDULE_INFUSION_SPEED_INPUT = 'infusion-admin-by-schedule-infusion-speed-input',
  INFUSION_ADMIN_BY_SCHEDULE_JUSTIFICATION_FIELD = 'infusion-admin-by-schedule-justification-field',
  INFUSION_ADMIN_BY_SCHEDULE_JUSTIFICATION_TEXT = 'infusion-admin-by-schedule-justification-text',
  INFUSION_ADMIN_BY_SCHEDULE_LAYOUT = 'infusion-admin-by-schedule-layout',
  INFUSION_ADMIN_BY_SCHEDULE_NAME_DATE_PANEL = 'infusion-admin-by-schedule-name-date-panel',
  INFUSION_ADMIN_BY_SCHEDULE_NAME_FIELD = 'infusion-admin-by-schedule-name-field',
  INFUSION_ADMIN_BY_SCHEDULE_NAME_TEXT = 'infusion-admin-by-schedule-name-text',
  INFUSION_ADMIN_BY_SCHEDULE_NEW_DATE_FIELD = 'infusion-admin-by-schedule-new-date-field',
  INFUSION_ADMIN_BY_SCHEDULE_NEW_DATE_INPUT = 'infusion-admin-by-schedule-new-date-input',
  INFUSION_ADMIN_BY_SCHEDULE_OBSERVATION_FIELD = 'infusion-admin-by-schedule-observation-field',
  INFUSION_ADMIN_BY_SCHEDULE_OBSERVATION_TEXT = 'infusion-admin-by-schedule-observation-text',
  INFUSION_ADMIN_BY_SCHEDULE_UNITY_AUTOCOMPLETE = 'infusion-admin-by-schedule-unity-autocomplete',
  INFUSION_ADMIN_BY_SCHEDULE_UNITY_FETCH = 'infusion-admin-by-schedule-unity-fetch',
  INFUSION_ADMIN_BY_SCHEDULE_UNITY_FIELD = 'infusion-admin-by-schedule-unity-field',
  INFUSION_ADMIN_BY_SCHEDULE_UNITY_MAPPER = 'infusion-admin-by-schedule-unity-mapper',
  INFUSION_ADMIN_BY_SCHEDULE_UNITY_TEXT = 'infusion-admin-by-schedule-unity-text',
  INFUSION_ADMIN_BY_SCHEDULE_VOLUME_STEP_FIELD = 'infusion-admin-by-schedule-volume-step-field',
  INFUSION_ADMIN_BY_SCHEDULE_VOLUME_STEP_INPUT = 'infusion-admin-by-schedule-volume-step-input',
  LEGENDS_INFUSION_ADMIN_BY_SCHEDULE = 'legends-infusion-admin-by-schedule',
}
export { InfusionAdministrationByScheduleAliases };
